import React from 'react';
import Typography from '@material-ui/core/Typography';
import Placeholder from '../Placeholder/Placeholder';

const Tile = ({ title, value, placeholderSize }) => (
  <div className="infotile padding-sm text-center flex">
    <Typography component={'span'} variant="subtitle1" style={{ opacity: .6 }}>
      {title}
    </Typography>

    <Typography component={'span'} variant="body1">
      {
        value ?
          <span style={{ opacity: .8 }}>{value}</span> :
          <Placeholder size={placeholderSize || 4} />
      }
    </Typography>
  </div>
);

export default Tile;
